enum EEquipmentPurchaseActions {
    INITIALIZED = '@equipment/purchase/initialized',
    FINALIZATION = '@equipment/purchase/finalization',

    ADD_ITEM = '@equipment/purchase/item/add',
    INC_ITEM = '@equipment/purchase/item/increment',
    DEC_ITEM = '@equipment/purchase/item/decrement',
    REMOVE_ITEM = '@equipment/purchase/item/remove',
    SELECT_COST = '@equipment/purchase/item/selectCost',

    FILL_PERSON = '@equipment/purchase/contactDetails/person/fill',
    FILL_PHONE = '@equipment/purchase/contactDetails/phone/fill',
    CONFIRM_CONTACT_DETAILS = '@equipment/purchase/contactDetails/confirm',

    FILL_CONTACT_DETAILS = '@equipment/purchase/contactDetails/fill',

    DELIVERY_ADDRESS_SELECTION = '@equipment/purchase/delivery/address/selection',
    DELIVERY_ADDRESS_SELECTED = '@equipment/purchase/delivery/address/selected',

    SET_STAGE = '@equipment/purchase/stage/set',

    ORDER_IS_BEING_PROCESSED = '@equipment/purchase/order/processing/being',
    ORDER_PROCESSING_FAILED = '@equipment/purchase/order/processing/failed',
    CREATING_ORDER = '@equipment/purchase/order/creating',
    ORDER_CREATED = '@equipment/purchase/order/created',
    FLUSH_ORDER_PROCESSING = '@equipment/purchase/order/flushProcessing',
}

export default EEquipmentPurchaseActions;
